var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-contact wrap"},[_c('h2',{attrs:{"id":"mailto"}},[_vm._v("Contact")]),_vm._m(0),_c('HomeContactContactForm',{staticClass:"contact-form"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"sub-title"},[_vm._v("お仕事のご依頼・"),_c('br',{staticClass:"sp-only"}),_vm._v("求人に関するお問い合わせ")])
}]

export { render, staticRenderFns }